import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser, refreshUsage } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(data.user);
        await refreshUsage();
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch {
        setError(true);
        setTimeout(() => navigate("/", { replace: true }), 1500);
      }
    })();
  }, [location, navigate, setUser, refreshUsage]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#F8FAFC]">
      <Loader2 className="w-8 h-8 animate-spin text-[#0052CC]" />
      <p className="mt-3 text-slate-500 font-medium">{error ? "Échec de connexion, redirection..." : "Connexion en cours..."}</p>
    </div>
  );
}
